import { customElement } from "lit/decorators.js";

import { SugarElement } from "../viewport/SugarCanvas";
import { Entity } from "../../engine/Engine";
import type { PointerGestureInterpreter } from "../../input/PointerGestureInterpreter";
import { PointerGestureInterpreterEntity } from "./PointerGestureInterpreterEntity";

/**
 * `sugar-viewport` içinde **en üstte** (ör. `room-designer` önünde) kullanın; böylece
 * `entity-created` sırası ve `begin()` önce bu entity’de çalışır.
 */
@customElement("pointer-gesture-interpreter")
export class PointerGestureInterpreterElement extends SugarElement {
  get pointerGestures(): PointerGestureInterpreter | undefined {
    return (this.entity as PointerGestureInterpreterEntity | undefined)
      ?.pointerGestures;
  }

  createEntity(): Entity | undefined {
    return new PointerGestureInterpreterEntity(
      this.eventPlatform?.designer.input.events,
    );
  }
}
